"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _RelevancesStore = _interopRequireDefault(require("./RelevancesStore2"));

var RelevancesActions = /*#__PURE__*/function () {
  function RelevancesActions() {
    (0, _classCallCheck2["default"])(this, RelevancesActions);
  }

  (0, _createClass2["default"])(RelevancesActions, null, [{
    key: "removeAspectsExcept",
    value: function removeAspectsExcept(keptAspects) {
      _RelevancesStore["default"].removeAspectsExcept(keptAspects);
    }
  }, {
    key: "setAvailableAspects",
    value: function setAvailableAspects(availableAspects) {
      _RelevancesStore["default"].setAvailableAspects(availableAspects);
    }
  }, {
    key: "setAvailableAspectsAndRelevances",
    value: function setAvailableAspectsAndRelevances(availableAspects, relevances) {
      _RelevancesStore["default"].setAvailableAspectsAndRelevances(availableAspects, relevances);
    }
  }, {
    key: "setCurrentAspect",
    value: function setCurrentAspect(aspect) {
      _RelevancesStore["default"].setCurrentAspect(aspect);
    }
  }, {
    key: "setRelevances",
    value: function setRelevances(relevances) {
      _RelevancesStore["default"].setRelevances(relevances);
    }
  }]);
  return RelevancesActions;
}();

var _default = RelevancesActions;
exports["default"] = _default;